export function isSelectedPaymentMethod(
  currentPaymentMethod: string,
  paymentMethod: string
): boolean {
  return currentPaymentMethod === paymentMethod;
}
